/**
 * Centralized i18n configuration (CommonJS version for gatsby-node.js)
 *
 * NOTE: This file is required by gatsby-node.js which runs in Node.js.
 * For TypeScript imports, use i18n-config.ts instead.
 */

// Supported languages
const SUPPORTED_LANGUAGES = ['en', 'es', 'de', 'fr', 'it', 'nl', 'pt'];

// Default language (US English)
const DEFAULT_LANGUAGE = 'en';

// Language to locale mapping for hreflang tags
const LANGUAGE_LOCALE_MAP = {
  en: 'en-US',
  es: 'es-ES',
  de: 'de-DE',
  fr: 'fr-FR',
  it: 'it-IT',
  nl: 'nl-NL',
  pt: 'pt-BR',
};

// Language names for display purposes
const LANGUAGE_NAMES = {
  en: 'English',
  es: 'Español',
  de: 'Deutsch',
  fr: 'Français',
  it: 'Italiano',
  nl: 'Nederlands',
  pt: 'Português',
};

// Get language from URL pathname
const getLanguageFromPath = (pathname) => {
  const pathParts = pathname.split('/').filter(Boolean);
  const potentialLang = pathParts[0];
  if (SUPPORTED_LANGUAGES.includes(potentialLang)) {
    return potentialLang;
  }
  return DEFAULT_LANGUAGE;
};

// Get base path without language prefix
const getBasePathWithoutLanguage = (pathname) => {
  if (!pathname || pathname === '/') {
    return '/';
  }

  const pathParts = pathname.split('/').filter(Boolean);
  const language = getLanguageFromPath(pathname);

  if (language !== DEFAULT_LANGUAGE) {
    const basePath = '/' + pathParts.slice(1).join('/');
    return basePath || '/';
  }

  return pathname;
};

module.exports = {
  SUPPORTED_LANGUAGES,
  DEFAULT_LANGUAGE,
  LANGUAGE_LOCALE_MAP,
  LANGUAGE_NAMES,
  getLanguageFromPath,
  getBasePathWithoutLanguage,
};
